export class ResumenImputacion {
  totalHours: string;
  totalHoursImputation: string;
  activityTypeS1: DatosImputacion[];
  activityTypeS2: DatosImputacion[];
  activityTypeS3: DatosImputacion[];
  totalPending: any;

  constructor() {
    this.activityTypeS1 = [];
    this.activityTypeS2 = [];
    this.activityTypeS3 = [];
  }
}

export class DatosImputacion {
  hours: string;
  projectId: string;
  sapId: string;
}
